<script setup>
import { AisRefinementList } from "vue-instantsearch/vue3/es"
import Refinement from "@/Components/Algolia/Refinement.vue"
</script>

<template>
<AisRefinementList v-bind="$attrs">
  <template
    v-slot="{
      items,
      isShowingMore,
      isFromSearch,
      canToggleShowMore,
      refine,
      createURL,
      toggleShowMore,
      searchForItems,
      sendEvent,
    }"
  >
    <ul>
      <li v-for="item in items" :key="item.value">
        <Refinement :refine="refine" :item="item" />
      </li>
    </ul>
    <button
      class="text-sm text-indigo-500 hover:underline"
      @click="toggleShowMore"
      v-if="canToggleShowMore"
    >
      {{ !isShowingMore ? 'Show more' : 'Show less'}}
    </button>
  </template>
</AisRefinementList>
</template>

